import { Divider, Modal, Typography } from 'antd';
import { MessageTypeEnum } from 'api/MessagesApi';
import { useGetFileMessageSysAdminQuery, useGetOneMessageSysAdminQuery } from 'api/SysAdminApi';
import DownloadLink from 'components/Message/DownloadLink/DownloadLink';
import SpinComponent from 'components/Tool/SpinComponent/SpinComponent';
import { AppAudioPlayer } from 'components/UiKit/Media/AppAudioPlayer';
import { AppVideoPlayer } from 'components/UiKit/Media/AppVideoPlayer';
import { TextToHtmlComponent } from 'components/UiKit/TextToHtmlComponent/TextToHtmlComponent';
import { useSelector } from 'react-redux';
import { closeModal, selectModalData, selectModalName } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import { isAudioFile, isVideoFile } from 'utils/utils';
import './SysAdminPreviewMessageModalComponent.css';

export const SYSADMIN_PREVIEW_MESSAGE_MODAL_NAME = 'SYSADMIN_PREVIEW_MESSAGE_MODAL_NAME';

type AllProps = {
  messageId: string;
};

function SysAdminPreviewMessageModalComponent({ messageId }: AllProps) {
  const dispatch = useAppDispatch();

  const { data: message, isLoading } = useGetOneMessageSysAdminQuery({ id: messageId });
  const { data: messageFile, isLoading: isLoadingFile } = useGetFileMessageSysAdminQuery({ id: messageId });

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      open={true}
      title="Preview File"
      onOk={handleCloseModal}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <SpinComponent isLoading={isLoading || isLoadingFile}>
        <div className="sysadmin-preview-message-modal-component">
          {message && (
            <>
              <p>
                Message title: <strong>{message.name}</strong>
              </p>

              <div className="message-content">
                {message.fileName ? (
                  (() => {
                    const fallback = (
                      <>
                        File: <strong>{message.fileName}</strong>
                      </>
                    );

                    if (message.type === MessageTypeEnum.Video && isVideoFile(message.fileName)) {
                      return (
                        <AppVideoPlayer url={messageFile?.signedUrl} fileName={message.fileName} fallback={fallback} />
                      );
                    }

                    if (message.type === MessageTypeEnum.Audio && isAudioFile(message.fileName)) {
                      return (
                        <AppAudioPlayer url={messageFile?.signedUrl} fileName={message.fileName} fallback={fallback} />
                      );
                    }

                    return fallback;
                  })()
                ) : message.type === MessageTypeEnum.Text ? (
                  <TextToHtmlComponent text={message.content} />
                ) : null}
              </div>

              <p>
                Click <DownloadLink message={message} messageFile={messageFile} text="here" /> to download
              </p>

              <Divider />

              <div>
                <h4>Contacts</h4>
                {message.contacts &&
                  message.contacts.map((contact) => (
                    <div key={contact.id} className="contact-content">
                      <Typography.Text>
                        <div>Name: {contact.name}</div>
                        <div>Email: {contact.email}</div>
                        <div>Phone: {contact.phone}</div>
                        <div>Relationship: {contact.relationship}</div>
                      </Typography.Text>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </SpinComponent>
    </Modal>
  );
}

function SysAdminPreviewMessageModalComponentWrapper() {
  const modalName = useSelector(selectModalName);
  const modalData = useSelector(selectModalData);
  const messageId = modalData?.id || null;

  return modalName === SYSADMIN_PREVIEW_MESSAGE_MODAL_NAME ? (
    <SysAdminPreviewMessageModalComponent messageId={messageId} />
  ) : null;
}

export default SysAdminPreviewMessageModalComponentWrapper;
